

exports.__esModule = true;
exports.$SidebarUpdateCardRoute = undefined;

var _squid = require('squid');

require('xo-wallet-components/src/add-card/route');

require('./directive');

var $SidebarUpdateCardRoute = exports.$SidebarUpdateCardRoute = _squid.$Route.extend('$SidebarUpdateCardRoute', {
    params: {
        planId: null,
        doneUri: null
    },
    path: 'sidebarUpdateCard',
    directive: 'xo-sidebar-update-card',
    titleContent: 'asideHeader.updateCard',
    trackingData: {
        templateName: 'tray/updateCard.dust',
        pageGoal: 'update Card',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-update-cc',
                'pagename2': '%::fullpage-update-cc:member:hermes:tray',
                'version': 'member:%:tray'
            }
        }
    },
    children: [{
        name: '$AddCardFlowRoute',
        attributes: {
            token: 'token',
            message: 'message',
            sidebar: 'sidebar',
            'parent-callbacks': 'callbacks',
            logout: 'logout',
            fundingid: 'fundingid',
            'back-uri': 'backUri'
        }
    }]
});

angular.value("$SidebarUpdateCardRoute", $SidebarUpdateCardRoute);
_squid.$Route;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar-update-card/route.js
// module id = ./pages/xo-sidebar-update-card/route.js
// module chunks = 0